export const ROW_INDEX_FIELD = '___#___';
export const ROW_ERROR_FIELD = '___error___';
export const ROW_WARNING_FIELD = '___warning___';

export const NUM_DATA_ROWS = 10;
